import { TFunction } from '@mint-lib/i18n';
import { z } from 'zod';

export const StringWithMaxLength = (t: TFunction, length: number) =>
  z
    .string()
    .trim()
    .max(length, {
      message: t('Max {{count}} characters', { count: length }),
    });

export const StringWithMaxLengthRequired = (t: TFunction, length: number) =>
  z
    .string()
    .trim()
    .min(1, 'Required')
    .max(length, {
      message: t('Max {{count}} characters', { count: length }),
    });
